import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'lib-dropdown-chips',
  templateUrl: './dropdown-chips.component.html',
  styleUrls: ['./dropdown-chips.component.scss'],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DropdownChipsComponent implements OnChanges {
  @Input() fieldName = '';
  @Input() options: any = [5, 10, 15, 20, 25];
  @Output() selectedDropdownValue = new EventEmitter<any>();
  @Input() isReadOnly = false;
  @Input() isSubmitted = false;
  @Input() required = false;
  @Input() showLabel = false;
  @Input() isFromTransload = false;

  @Input() selectedOption: string | null = null;
  public dropdownOpen = false;
  public touched = false;
  public showError = false;
  public showWarning = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isSubmitted']) {
      this.updateStatus();
    }
    if (changes['selectedOption']) {
      this.updateStatus();
    }
  }

  toggleDropdown(): void {
    if (!this.isReadOnly) {
      this.dropdownOpen = !this.dropdownOpen;
    }
  }

  selectOption(option: string): void {
    this.selectedOption = option;
    this.dropdownOpen = false;
    this.selectedDropdownValue.emit(this.selectedOption);
    this.updateStatus();
  }

  clearSelection(): void {
    this.selectedOption = null;
    this.selectedDropdownValue.emit(this.selectedOption);
    this.updateStatus();
  }

  closeDropdown(): void {
    this.dropdownOpen = false;
  }

  private hasValue(): boolean {
    return !!this.selectedOption;
  }

  private computeError(): boolean {
    return this.required && this.isSubmitted && !this.hasValue();
  }

  private computeWarning(): boolean {
    return (
      this.required && this.touched && !this.hasValue() && !this.isSubmitted
    );
  }

  updateStatus(): void {
    this.showError = this.computeError();
    this.showWarning = this.computeWarning();
  }

  onBlur(): void {
    this.touched = true;
    this.updateStatus();
  }
}
